// extracted by mini-css-extract-plugin
export var quillEditor = "_n1-1";
export var variable = "_n1-0";